var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 23,
  height: 23,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m6.003 8.497 4.743-4.742v11.73H12.26V3.755l4.743 4.742.07.07.071-.07.928-.928.071-.07-.07-.071L11.572.929l-.07-.07-.071.07-6.498 6.499-.071.07.07.071.929.928.07.07.071-.07Z",
  fill: "#662D91",
  stroke: "#662D91",
  strokeWidth: 0.2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.593 14.729v5.807H2.413V14.628H.9V22.05H22.105V14.63H20.592v.1Z",
  fill: "#662D91",
  stroke: "#662D91",
  strokeWidth: 0.2
})));
export { SvgUpload as ReactComponent };
export default __webpack_public_path__ + "56704917388c981c4e81fef62ebc6f2f.svg";